import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const IdentificationChartsDataContext = createContext();

const IdentificationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.IDENTIFICATION_MORTALITY,
            url: 'governanceroom/dashboard/vitalstatistics/mortality/id'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              scholarity: data?.scholarity ?? [],
              studySeries: data?.studySeries ?? [],
              ageGroup: data?.ageGroup ?? [],
              gender: data?.gender ?? [],
              maritalStatus: data?.maritalStatus ?? []
          }
        : {
              scholarity: [],
              studySeries: [],
              ageGroup: [],
              gender: [],
              maritalStatus: []
          };

    return (
        <IdentificationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </IdentificationChartsDataContext.Provider>
    );
};

export default IdentificationChartsDataProvider;
